/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "uyavxanmcwfelwqwsesr"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV5YXZ4YW5tY3dmZWx3cXdzZXNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc0NzA3NjQsImV4cCI6MjA4MzA0Njc2NH0.c2mq6vKJnTecJ2ydjeuluY9kxZY3tR3Lp4NO5hBRV5U"